
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Navigation } from 'swiper'
SwiperCore.use([Navigation])
export default {
  name: 'honorary',
  data() {
    return {
      index: 0,
      honorary: [
        {
          date: '2024年4月',
          desc: '4月16日，获得美团金融颁发的“2023年度委外合作厂商核心贡献奖”',
          img: 'web04.png'
        }, 
        {
          date: '2024年3月',
          desc: '3月1日，获得京东金融颁发的“2023年度委外合作砥砺奋进奖”',
          img: 'web03.png'
        }, 
        {
          date: '2024年3月',
          desc: '3月1日，获得京东金融颁发的“2023年度委外合作核心机构”',
          img: 'web02.png'
        }, 
        {
          date: '2024年2月',
          desc: '2月21日，获得携程金融颁发的“2023年携程金融最佳合作机构”',
          img: 'web01.png'
        }, 
        {
          date: '2023年3月',
          desc: '3月21日，互连众信获评北京市“专精特新”中小企业',
          img: '2023_3.png'
        }, 
        {
          date: '2023年1月',
          desc: '1月31日，携程金融授予的“2022年度优秀合作机构”荣誉称号',
          img: '2023_2.png'
        }, 
        {
          date: '2023年1月',
          desc: '1月17日，获得美团金融颁发的“2022年度委外合作厂商——卓越贡献奖”',
          img: '2023_1.png'
        }, 
        {
          date: '2022年12月',
          desc: '入围2022年度北京市创新信用领跑企业',
          img: '2022_08.png'
        }, 
        {
          date: '2022年11月',
          desc: '互连众信获评北京市朝阳区创新型中小企业',
          img: '2022_07.png'
        }, 
        {
          date: '2022年5月',
          desc: '灵晖入选“金智奖·第四届金融数据智能优秀解决方案”',
          img: '2022_06.png'
        }, 
        {
          date: '2022年4月',
          desc: '企业入选“朝阳区未来独角兽加速计划”',
          img: '2022_05.png'
        }, {
          date: '2022年2月',
          desc: '获得京东科技授予的“2021年度贷后管理最佳合作机构”荣誉称号',
          img: '2022_04.png'
        }, {
          date: '2022年1月',
          desc: '成为中原银行信用卡中心“不良资产处置二级核心机构”',
          img: '2022_03.png'
        }, {
          date: '2022年1月',
          desc: '获得美团金服颁发的“2021年度委外合作厂商精诚合作奖”',
          img: '2022_02.png'
        },
        {
          date: '2022年1月',
          desc: '获得京东科技颁发的“2021年度砥砺奋进奖”',
          img: '2022_01.png'
        }, {
          date: '2021年5月',
          desc: '获得野马财经2021年度新金融领军榜“创新产品奖”',
          img: '2021_2.png'
        }, {
          date: '2021年1月',
          desc: '入选“零壹财经小微金融数字服务商Top30”',
          img: '2021_1.png'
        }, {
          date: '2020年8月',
          desc: '入围2020 爱分析•中国智慧金融厂商榜单，服务案例列入“爱分析银行数字化厂商全景报告”',
          img: '2020_1.png'
        }, {
          date: '2019年11月',
          desc: '入选德勤“2019中国高科技高成长50强”',
          img: '2019_7.png'
        }, {
          date: '2019年11月',
          desc: '入选德勤中国-北京朝阳高科技高成长20强',
          img: '2019_6.png'
        }, {
          date: '2019年10月',
          desc: '荣获爱分析新龙榜-中国科技创新企业100强',
          img: '2019_5.png'
        }, {
          date: '2019年9月',
          desc: '入选创业邦“2019中国金融科技创新企业30强”',
          img: '2019_4.png'
        }, {
          date: '2019年7月',
          desc: '项目获金科创新社“风控创新优秀解决方案”并入选《2019金融AI大数据产业发展白皮书》 ',
          img: '2019_3.png'
        }, {
          date: '2019年5月',
          desc: '荣获由2019数博会颁发的“优秀项目”荣誉',
          img: '2019_2.png'
        }, {
          date: '2019年3月',
          desc: '荣获由饮鹿网颁发的“2018-2019年中国金融科技产业创新百强榜”',
          img: '2019_1.png'
        }, {
          date: '2018年12月',
          desc: '荣获由创业邦颁发的“2018中国企业服务创新成长50强”',
          img: '2018_7.png'
        }, {
          date: '2018年11月',
          desc: '荣获由i黑马颁发的“未来高成长价值Top100企业”',
          img: '2018_6.png'
        }, {
          date: '2018年11月',
          desc: '获得由德勤颁发的“2018中国明日之星”奖项',
          img: '2018_5.png'
        }, {
          date: '2018年11月',
          desc: '在第二届中国商业银行风控战略大会中荣获“2018年度金融贷后产品创新奖”',
          img: '2018_4.png'
        }, {
          date: '2018年6月',
          desc: '获得由2018第五届FEA消费金融国际峰会颁发的“最佳不良资产处置服务奖”',
          img: '2018_3.png'
        }, {
          date: '2018年1月',
          desc: '荣获由猎云网颁发的“最佳科技金融创业公司”奖项',
          img: '2018_2.png'
        }, {
          date: '2018年1月',
          desc: '获得由中国董事局、中国数据研究中心颁发的“2017中国最具影响力新金融大奖”',
          img: '2018_1.png'
        }, {
          date: '2017年5月',
          desc: '荣获由2016中国国际消费金融发展大会组委会颁发的“不良资产处置平台优质服务奖”',
          img: '2017_2.png'
        }, {
          date: '2017年',
          desc: '荣获由中国互联网金融消费者权益保护工作经验交流组委会颁发的“特别贡献奖”',
          img: '2017_1.png'
        }, {
          date: '2016年9月',
          desc: '荣获由直讯中国颁发的“不良资产处置领军企业”奖',
          img: '2016_2.png'
        }, {
          date: '2016年1月',
          desc: '获得由中国金融创新发展论坛组委会办公室颁发的“中国互联网金融最具成长力企业”荣誉证书',
          img: '2016_1.png'
        }
      ],
      resultData: []
    }
  },
  created() {
    let result = [];
    for(let i=0; i<this.honorary.length; i+=8){
      result.push(this.honorary.slice(i, i+8));
    }
    this.resultData = result
  },
  mounted() {
  },
  methods: {
    handlePre() {
      if (this.index > 0) {
        --this.index
      }
    },
    handleNext() {
      if (this.index < this.resultData.length - 1) {
        ++this.index
      }
    },
    slideChangeTransitionEnd(e) {
      this.index = e.activeIndex
    }
  },
  components: {
    Swiper,
    SwiperSlide
  }
}
